export const TestWorkflowState = Object.freeze({
    APP_INIT: "appInit",
    IDLE: "idle",
    SESSION_INIT: "sessionInit",
    PRESENTING_STIMULUS: "presentingStimulus",
    WAITING_FOR_PROCESSING: "waitingForProcessing",
    NEXT_PART_REQUESTED: "nextPartRequested",
    BETWEEN_PARTS: "betweenParts",
    BACKEND_UPDATING: "backendUpdating",
});

export const TestWorkflowAction = Object.freeze({
    ENTER_APP_INIT: "testWorkflow/ENTER_APP_INIT",
    ENTER_IDLE: "testWorkflow/ENTER_IDLE",
    ENTER_SESSION_INIT: "testWorkflow/ENTER_SESSION_INIT",
    ENTER_PRESENTING_STIMULUS: "testWorkflow/ENTER_PRESENTING_STIMULUS",
    ENTER_WAITING_FOR_PROCESSING: "testWorkflow/ENTER_WAITING_FOR_PROCESSING",
    ENTER_NEXT_PART_REQUESTED: "testWorkflow/ENTER_NEXT_PART_REQUESTED",
    ENTER_BETWEEN_PARTS: "testWorkflow/ENTER_BETWEEN_PARTS",
    ENTER_BACKEND_UPDATING: "testWorkflow/ENTER_BACKEND_UPDATING",
    RESET: "testWorkflow/RESET",
});

export const INITIAL_TEST_WORKFLOW_STATE = TestWorkflowState.APP_INIT;

export function testWorkflowReducer(state = INITIAL_TEST_WORKFLOW_STATE, action) {
    switch (action.type) {
        case TestWorkflowAction.ENTER_APP_INIT:
            return TestWorkflowState.APP_INIT;
        case TestWorkflowAction.ENTER_IDLE:
            return TestWorkflowState.IDLE;
        case TestWorkflowAction.ENTER_SESSION_INIT:
            return TestWorkflowState.SESSION_INIT;
        case TestWorkflowAction.ENTER_PRESENTING_STIMULUS:
            return TestWorkflowState.PRESENTING_STIMULUS;
        case TestWorkflowAction.ENTER_WAITING_FOR_PROCESSING:
            return TestWorkflowState.WAITING_FOR_PROCESSING;
        case TestWorkflowAction.ENTER_NEXT_PART_REQUESTED:
            return TestWorkflowState.NEXT_PART_REQUESTED;
        case TestWorkflowAction.ENTER_BETWEEN_PARTS:
            return TestWorkflowState.BETWEEN_PARTS;
        case TestWorkflowAction.ENTER_BACKEND_UPDATING:
            return TestWorkflowState.BACKEND_UPDATING;
        case TestWorkflowAction.RESET:
            return INITIAL_TEST_WORKFLOW_STATE;
        default:
            return state;
    }
}

// Version polling once on appInit, in "idle" (every 30s) and "backendUpdating" (every 2s)
export const shouldPollVersion = (state) =>
    state === TestWorkflowState.APP_INIT ||
    state === TestWorkflowState.IDLE ||
    state === TestWorkflowState.BACKEND_UPDATING; 

// Running polling only while waiting for processing to finish
export const shouldPollRunning = (state) =>
    state === TestWorkflowState.WAITING_FOR_PROCESSING;

